import isWithinInterval from './is-within-interval';

export { isWithinInterval };

export default isWithinInterval;
